import {
  CORRELATION_CARD,
  EVOLUTIVE_CARD,
  EVOLUTIVE_CROSS_CARD,
  MULTIPLE_CARD,
  SIMPLECROSS_CARD,
  SIMPLE_CARD,
} from "src/sections/GroupCards/cardTypes";
import { ChartManager } from "..";
import { EvolutiveChartManager } from "../evolutive";
import { MultiChartManager } from "../multi";
import { SimpleChartManager } from "../simple";
import { SimpleCrossChartManager } from "../simpleCross";
import { EvolutiveCrossChartManager } from "../evolutiveCross";
import { CorrelationChartManager } from "../correlation";

// Estratégias de obtenção dos gerenciadores de gráficos para cada card.
const strategies = {
  [SIMPLE_CARD]: SimpleChartManager,
  [MULTIPLE_CARD]: MultiChartManager,
  [SIMPLECROSS_CARD]: SimpleCrossChartManager,
  [EVOLUTIVE_CARD]: EvolutiveChartManager,
  [EVOLUTIVE_CROSS_CARD]: EvolutiveCrossChartManager,
  [CORRELATION_CARD]: CorrelationChartManager,
};

// Variável de controle de estado dos gerenciadores
const managers = {};

/**
 * Recupera uma instância de gerenciador do gráfico ativo dado um card.
 * @param {string} identifier Identificador do card de controle do gerenciador
 * @returns {SimpleChartManager | MultiChartManager | SimpleCrossChartManager | EvolutiveChartManager | ChartManager}
 */
export const getChartManagerInstance = function (identifier) {
  return managers[identifier];
};

// Remove instâncias de gerenciadores instanciados no gráfico de cruzamentos
// simples
export const removeSimpleCrossManager = function (manager) {
  if (Array.isArray(managers[SIMPLECROSS_CARD])) {
    managers[SIMPLECROSS_CARD].splice(managers[SIMPLECROSS_CARD].indexOf(manager), 1);
  }
};

/**
 * Resolve qual gerenciador deve ser utilizado de acordo com o tipo de card passado por parâmetro.
 * Essa função tem duas responsabilidades: Resolver o gerenciador que será utilizado pelo gráfico
 * e armazenar as instâncias desses gerenciadores para serem externalizados
 * e utilizados quando necessário.
 * @returns {SimpleChartManager | MultiChartManager | SimpleCrossChartManager | EvolutiveChartManager | ChartManager}
 */
export const useChartManagement = function (instance) {
  // Armazena as instâncias dos gerenciadores dos gráficos de cruzamentos
  // simples atualmente ativos.
  const storeSimpleCrossManager = (manager) => {
    if (!managers[SIMPLECROSS_CARD]) {
      managers[SIMPLECROSS_CARD] = [];
    }

    managers[SIMPLECROSS_CARD].push(manager);
  };

  // Armazena as instâncias dos gerenciadores dos gráficos
  const storeManager = (identifier, manager) => {
    if (identifier === SIMPLECROSS_CARD) {
      return storeSimpleCrossManager(manager);
    }
    managers[identifier] = manager;
  };

  const resolveManager = () => {
    const { cardType } = instance.props;

    let manager;

    if (strategies[cardType]) {
      manager = new strategies[cardType](instance);
    } else {
      manager = new ChartManager(instance);
    }

    storeManager(cardType, manager);

    return manager;
  };

  return resolveManager();
};
